/* eslint-disable no-use-before-define */
import { makeStyles, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import i18n from 'i18n';
import React from 'react';
import {
  GenericFormItem,
  GenericFormItemOptions,
} from 'skyone-lib/lib/GenericForm/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  errors: any;
  loading?: boolean;
  loadingText?: string;
  initialValuesAutoComplete?: any;
  noOptionsText?: string;
  overrideWidth?: boolean;
  disableClearable?: boolean;
  options: any;
  setFieldValue?: (field: string, value: any) => void;
  onChange?: (event: React.ChangeEvent<{}>, value: any) => void;
  onInputChange?: (
    event: React.ChangeEvent<{}>,
    value: any,
    reason: 'reset' | 'input'
  ) => void;
}

const AutocompleteSelect = ({
  errors,
  stateKey,
  options,
  label,
  loading,
  loadingText,
  noOptionsText,
  initialValuesAutoComplete,
  overrideWidth,
  disableClearable,
  setFieldValue,
  onChange,
  onInputChange,
}: GenericFormItem & Props) => {
  const classes = useStyles(overrideWidth);

  const [values, setValues] = React.useState<GenericFormItemOptions>({
    value: initialValuesAutoComplete?.value,
    label: initialValuesAutoComplete?.label,
  });

  React.useEffect(() => {
    setValues({
      value: initialValuesAutoComplete?.value,
      label: initialValuesAutoComplete?.label,
    });
  }, [initialValuesAutoComplete]);

  return (
    <>
      <Autocomplete
        value={values}
        id={stateKey}
        data-testid="autosky-autocomplete"
        options={options}
        getOptionLabel={option => option.label || ''}
        className={classes.root}
        renderInput={params => (
          <TextField
            {...params}
            key={label}
            label={label}
            variant="outlined"
            fullWidth
            error={!!errors[stateKey]}
            helperText={errors[stateKey]}
          />
        )}
        onInputChange={() => {
          return onInputChange;
        }}
        onChange={(event, value) => {
          if (onChange) onChange(event, value || '');
          if (setFieldValue) setFieldValue(stateKey, value?.value || '');
        }}
        loading={loading}
        loadingText={loadingText || `${i18n.t('LOADING_KEY')}...`}
        noOptionsText={noOptionsText || i18n.t('NOT_FOUND_KEY')}
        disableClearable={disableClearable}
      />
    </>
  );
};

export default AutocompleteSelect;
